// @ts-check
export const hasNav = item => item && item.nav && item.nav.length > 0;
